/**
 * Created by jomsm on 24/07/2017.
 */
(function() {

    'use strict';

    angular.module('app').
    controller('serviceRateCardsController', serviceRateCardsController);

    serviceRateCardsController.$inject = ['Carrier', 'serviceRateCardsTableService','$routeParams'];

    function serviceRateCardsController(Carrier, serviceRateCardsTableService, $routeParams) {

        var vm = this;
        let carrierProfileId = $routeParams.carrierProfileId;
        let serviceProfileId = $routeParams.serviceProfileId;
        vm.serviceDetailsList = {};
        let carrierId = $routeParams.carrier;
        init();

        function init() {
            vm.serviceRateCardsTable = new serviceRateCardsTableService(carrierProfileId, serviceProfileId).tableData;
            /*var paginationData = {
                size: 20,
                page: 0,
                sort: 'clientId'
            };
            getCarrierProfiles(paginationData);*/
        }

    }
})();


// WEBPACK FOOTER //
// ./js/controllers/carriers/serviceRateCardsController.js